import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/layout/Header";
import CookieBanner from "./components/layout/CookieBanner";
import Home from "./pages/Home/Home";
import Services from "./pages/Services/Services";
import Investment from "./pages/Services/Investment";
import Management from "./pages/Services/Management";
import Corporate from "./pages/Corporate/Corporate";
import Company from "./pages/Corporate/Company";
import Technology from "./pages/Corporate/Technology";
import Contact from "./pages/Contact/Contact";
import AvisoLegal from "./pages/Legal/AvisoLegal";
import PoliticaPrivacidad from "./pages/Legal/PoliticaPrivacidad";
import PoliticaCookies from "./pages/Legal/PoliticaCookies";
import PoliticaSeguridad from "./pages/Legal/PoliticaSeguridad";
import CanalEtico from "./pages/Legal/CanalEtico";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/servicios/inversion" element={<Investment />} />
            <Route path="/servicios/gestion" element={<Management />} />
            <Route path="/corporativo" element={<Corporate />} />
            <Route path="/corporativo/compania" element={<Company />} />
            <Route path="/corporativo/tecnologia" element={<Technology />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/politica-seguridad" element={<PoliticaSeguridad />} />
            <Route path="/canal-etico" element={<CanalEtico />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
